// Decouples "something changed, please sync" (called from mutations) from the
// actual sync+invalidate runner (registered by AppProvider, which has the
// query client). Debounced so a burst of edits triggers one sync.

let runner: () => void = () => {};
let timer: number | null = null;

export function setSyncRunner(fn: () => void): void {
  runner = fn;
}

export function requestSync(): void {
  if (timer != null) return;
  timer = window.setTimeout(() => {
    timer = null;
    runner();
  }, 400);
}
